import { apiGet, apiPut } from '@api/api.utils'
import { IResponseCommon } from "../common.types"
import {
    IResponseFinalExaminationArchive,
    IResponseFinalExaminationListeners,
    IResponseFinalExaminationListenersCard,
} from "./api.types"


const route = '/finalExamination'


/** Получение списка итоговых работ */
export const getFinalExaminationListeners = (pageNumber: number, search?: string, signal?: AbortSignal): Promise<IResponseFinalExaminationListeners> =>
    apiGet<IResponseFinalExaminationListeners>(`${route}/getFinalExaminationList`, { params: { pageNumber, search }, signal })

/** Получение списка итоговых работ из архива */
export const getFinalExaminationArchive = (pageNumber: number, search?: string, isArchive: number = 1, signal?: AbortSignal): Promise<IResponseFinalExaminationArchive> =>
    apiGet<IResponseFinalExaminationArchive>(`${route}/getFinalExaminationList`, { params: { pageNumber, search, isArchive }, signal })



/** Получение данных по анкете итоговой аттестации */
export const getFinalExaminationCard = (finalExaminationID: number): Promise<IResponseFinalExaminationListenersCard> =>
    apiGet<IResponseFinalExaminationListenersCard>(`${route}/getFinalExaminationCard`, { params: { finalExaminationID } })

/** Сохранение данных по анкете слушателя */
export const setFinalExaminationCardSave = (
    finalExaminationID: number,
    themeIAR: string,
    iarScore: string,
    testScore: string
): Promise<IResponseCommon> =>
    apiPut<IResponseCommon>(`${route}/setFinalExaminationCardSave`, {
        params: { finalExaminationID, themeIAR, iarScore, testScore },
    })



/** Отправка итоговой работы слушателя на печать */
export const setFinalExaminationToPrint = (finalExaminationID: number): Promise<IResponseCommon> =>
    apiPut<IResponseCommon>(`${route}/setFinalExaminationToPrint`, { params: { finalExaminationID } })

/** Перемещение итоговой работы слушателя в архив */
export const setFinalExaminationInArchive = (finalExaminationID: number): Promise<IResponseCommon> =>
    apiPut<IResponseCommon>(`${route}/setFinalExaminationInArchive`, { params: { finalExaminationID } })

/** Перемещение анкеты итоговой работы слушателя обратно на обработку */
export const setFinalExaminationWithArchive = (finalExaminationID: number): Promise<IResponseCommon> =>
    apiPut<IResponseCommon>(`${route}/setFinalExaminationWithArchive`, { params: { finalExaminationID } })
